"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportStatus = exports.TopicFlags = exports.TOPIC_PERMISSION_MASK = exports.TOPIC_STATE_MASK = exports.TopicPermissionFlags = exports.TopicStateFlags = exports.ForumFlags = void 0;
exports.hasForumFlag = hasForumFlag;
exports.isForumCategory = isForumCategory;
exports.isCatalogTopic = isCatalogTopic;
exports.canWriteSimplePostInTopic = canWriteSimplePostInTopic;
exports.canUsePostTemplateInTopic = canUsePostTemplateInTopic;
exports.canCreateTopicInForum = canCreateTopicInForum;
exports.decodeForumFlags = decodeForumFlags;
exports.formatForumFlags = formatForumFlags;
exports.getTopicStateBitmask = getTopicStateBitmask;
exports.getTopicPermissionBitmask = getTopicPermissionBitmask;
exports.decodeTopicStateFlags = decodeTopicStateFlags;
exports.decodeTopicPermissionFlags = decodeTopicPermissionFlags;
exports.decodeTopicFlags = decodeTopicFlags;
exports.formatTopicStateFlags = formatTopicStateFlags;
exports.formatTopicPermissionFlags = formatTopicPermissionFlags;
exports.formatTopicFlags = formatTopicFlags;
/** Битовая маска форума/темы/поста (FourPDA.Core.FLAGS) */
exports.ForumFlags = {
    PINNED: 1,
    HIDDEN: 2,
    CLOSED: 4,
    FAVORITE: 8,
    /** Каталог на индексе форума; у тем — маркер/редирект */
    MARKER: 16,
    UPDATED: 32,
    CAN_POST: 64,
    CAN_EDIT: 128,
    CAN_DELETE: 256,
    CAN_MODERATE: 512,
};
const FORUM_FLAG_DEFINITIONS = [
    { bit: exports.ForumFlags.PINNED, id: 'pinned', label: 'Закреплено' },
    { bit: exports.ForumFlags.HIDDEN, id: 'hidden', label: 'Скрыто' },
    { bit: exports.ForumFlags.CLOSED, id: 'closed', label: 'Закрыто' },
    { bit: exports.ForumFlags.FAVORITE, id: 'favorite', label: 'В избранном' },
    { bit: exports.ForumFlags.MARKER, id: 'marker', label: 'Каталог' },
    { bit: exports.ForumFlags.UPDATED, id: 'updated', label: 'Есть обновления' },
    { bit: exports.ForumFlags.CAN_POST, id: 'can_post', label: 'Можно создавать темы' },
    { bit: exports.ForumFlags.CAN_EDIT, id: 'can_edit', label: 'Можно редактировать' },
    { bit: exports.ForumFlags.CAN_DELETE, id: 'can_delete', label: 'Можно удалять' },
    { bit: exports.ForumFlags.CAN_MODERATE, id: 'can_moderate', label: 'Модерация' },
];
/** Состояние темы — младшие биты bitmask [3] в списке тем (Forum.cs) */
exports.TopicStateFlags = {
    PINNED: exports.ForumFlags.PINNED,
    HIDDEN: exports.ForumFlags.HIDDEN,
    CLOSED: exports.ForumFlags.CLOSED,
    FAVORITE: exports.ForumFlags.FAVORITE,
    /** Marker: тема перенесена в другой раздел */
    MOVED: exports.ForumFlags.MARKER,
    UNREAD: exports.ForumFlags.UPDATED,
};
/** Права текущего пользователя на тему — старшие биты того же bitmask */
exports.TopicPermissionFlags = {
    CAN_REPLY: exports.ForumFlags.CAN_POST,
    CAN_EDIT: exports.ForumFlags.CAN_EDIT,
    CAN_DELETE: exports.ForumFlags.CAN_DELETE,
    CAN_MODERATE: exports.ForumFlags.CAN_MODERATE,
};
/** Маска состояния темы (биты 1–32) */
exports.TOPIC_STATE_MASK = exports.TopicStateFlags.PINNED |
    exports.TopicStateFlags.HIDDEN |
    exports.TopicStateFlags.CLOSED |
    exports.TopicStateFlags.FAVORITE |
    exports.TopicStateFlags.MOVED |
    exports.TopicStateFlags.UNREAD;
/** Маска прав на тему (биты 64–512) */
exports.TOPIC_PERMISSION_MASK = exports.TopicPermissionFlags.CAN_REPLY |
    exports.TopicPermissionFlags.CAN_EDIT |
    exports.TopicPermissionFlags.CAN_DELETE |
    exports.TopicPermissionFlags.CAN_MODERATE;
/** @deprecated Используйте TopicStateFlags */
exports.TopicFlags = exports.TopicStateFlags;
const TOPIC_STATE_DEFINITIONS = [
    { bit: exports.TopicStateFlags.PINNED, id: 'pinned', label: 'Закреплена' },
    { bit: exports.TopicStateFlags.HIDDEN, id: 'hidden', label: 'Скрыта' },
    { bit: exports.TopicStateFlags.CLOSED, id: 'closed', label: 'Закрыта' },
    { bit: exports.TopicStateFlags.FAVORITE, id: 'favorite', label: 'В избранном' },
    { bit: exports.TopicStateFlags.MOVED, id: 'moved', label: 'Перемещена' },
    { bit: exports.TopicStateFlags.UNREAD, id: 'unread', label: 'Непрочитано' },
];
const TOPIC_PERMISSION_DEFINITIONS = [
    { bit: exports.TopicPermissionFlags.CAN_REPLY, id: 'can_reply', label: 'Можно отвечать' },
    { bit: exports.TopicPermissionFlags.CAN_EDIT, id: 'can_edit', label: 'Можно редактировать' },
    { bit: exports.TopicPermissionFlags.CAN_DELETE, id: 'can_delete', label: 'Можно удалять' },
    { bit: exports.TopicPermissionFlags.CAN_MODERATE, id: 'can_moderate', label: 'Модерация' },
];
function hasForumFlag(flags, flag) {
    return (flags & flag) !== 0;
}
function isForumCategory(flags) {
    return hasForumFlag(flags, exports.ForumFlags.MARKER);
}
/** Тема-каталог / релизер (бит MARKER в bitmask темы). */
function isCatalogTopic(bitmask) {
    return hasForumFlag(bitmask, exports.ForumFlags.MARKER);
}
/** Обычный ответ через fp — не для каталогов. */
function canWriteSimplePostInTopic(bitmask) {
    return hasForumFlag(bitmask, exports.TopicPermissionFlags.CAN_REPLY) && !isCatalogTopic(bitmask);
}
/** Кастомная форма fw (релизер) — при наличии шаблона в настройках темы. */
function canUsePostTemplateInTopic(bitmask, postTemplateName) {
    return hasForumFlag(bitmask, exports.TopicPermissionFlags.CAN_REPLY) && Boolean(postTemplateName?.trim());
}
/** Создание новой темы в разделе (бит CAN_POST в flags ответа fs). */
function canCreateTopicInForum(flags) {
    return hasForumFlag(flags, exports.ForumFlags.CAN_POST);
}
function decodeForumFlags(flags) {
    return FORUM_FLAG_DEFINITIONS.filter((def) => hasForumFlag(flags, def.bit));
}
function formatForumFlags(flags, separator = ', ') {
    const labels = decodeForumFlags(flags).map((f) => f.label);
    return labels.length > 0 ? labels.join(separator) : '—';
}
function getTopicStateBitmask(bitmask) {
    return bitmask & exports.TOPIC_STATE_MASK;
}
function getTopicPermissionBitmask(bitmask) {
    return bitmask & exports.TOPIC_PERMISSION_MASK;
}
function decodeTopicStateFlags(bitmask) {
    const state = getTopicStateBitmask(bitmask);
    return TOPIC_STATE_DEFINITIONS.filter((def) => (state & def.bit) !== 0);
}
function decodeTopicPermissionFlags(bitmask) {
    const permissions = getTopicPermissionBitmask(bitmask);
    return TOPIC_PERMISSION_DEFINITIONS.filter((def) => (permissions & def.bit) !== 0);
}
/** Полная расшифровка bitmask темы: состояние + права */
function decodeTopicFlags(bitmask) {
    return [...decodeTopicStateFlags(bitmask), ...decodeTopicPermissionFlags(bitmask)];
}
function formatTopicStateFlags(bitmask, separator = ', ') {
    const labels = decodeTopicStateFlags(bitmask).map((f) => f.label);
    return labels.length > 0 ? labels.join(separator) : '—';
}
function formatTopicPermissionFlags(bitmask, separator = ', ') {
    const labels = decodeTopicPermissionFlags(bitmask).map((f) => f.label);
    return labels.length > 0 ? labels.join(separator) : '—';
}
function formatTopicFlags(bitmask, separator = ', ') {
    const labels = decodeTopicFlags(bitmask).map((f) => f.label);
    return labels.length > 0 ? labels.join(separator) : '—';
}
exports.ReportStatus = {
    SUCCESS: 0,
    LIMIT_ERROR: 2,
    NOT_FOUND: 3,
    TOO_SHORT: 4,
    UNKNOWN_ERROR: -1
};
